import type { CompletionRule, RequestStatus } from "@gw/shared-types";
import { fmtETDate } from "@/lib/format";
import { statusLabel } from "@/lib/labels";

const PRE_ONBOARDING_RULE_LABEL: Record<string, string> = {
  PreOnboardingWorkOrderCreated: "work order created",
  PreOnboardingWorkOrderApproved: "work order approved",
  PreOnboardingOnboardingCreated: "onboarding request created",
};

interface CompletionFacts {
  completionRule: CompletionRule | null;
  completedAt: Date | null;
  status: RequestStatus;
}

/**
 * Why a request reads Completed when FBO may still say otherwise, e.g. "Completed by the
 * pre-verification rule: work order approved on 2026-09-12 (FBO status: Pending Onboarding)" or
 * "Completed by the work-order rule: work order approved on … (FBO status: In Progress)". Null for
 * every request the standard rule decides, so the header shows no note.
 */
export function completionNote({ completionRule, completedAt, status }: CompletionFacts): string | null {
  const fbo = status === "Completed" ? "" : ` (FBO status: ${statusLabel(status)})`;
  if (completionRule === "WorkOrderApproved") {
    return `Completed by the work-order rule: work order approved on ${fmtETDate(completedAt)}${fbo}.`;
  }
  const what = PRE_ONBOARDING_RULE_LABEL[completionRule ?? ""];
  if (!what) {
    return null;
  }
  return `Completed by the pre-verification rule: ${what} on ${fmtETDate(completedAt)}${fbo}.`;
}
